import { Component, OnInit } from "@angular/core";
import { NotificationService } from "./../../_services/notification.service";
import { MatSnackBar } from "@angular/material";

@Component({
  selector: "app-notification-master",
  templateUrl: "./notification-master.component.html",
  styleUrls: ["./notification-master.component.scss"]
})
export class NotificationMasterComponent implements OnInit {
  /*
  constructor() { }
  ngOnInit() {
  }
*/
productLoading:Boolean=false
  notification: any;
  totalRecords:any = 0;
  page = 0;
notificationfilter: any = {
    notificationtitle: "",
    notificationstatus: "Active",
    appname:"",
    screenname:"",
    ncontent:"",
};

  size = 10;

  constructor(
    private notificationservice: NotificationService,
    private snackBar :MatSnackBar
  ) {}

  ngOnInit() {
    this.getnotificationlist(1, this.notificationfilter);
  }

  getnotificationlist(page: number, notificationfilter) {

    this.productLoading=true


    this.notificationservice.getnotificationlist(page - 1, this.size, notificationfilter).subscribe((response) => {
      if(response.status_code == 200){
        this.productLoading=false
        this.notification = response.Data;
        this.totalRecords = response.total_count;
        this.page = page;
      }else{
        this.productLoading=false
        this.snackBar.open(response.Metadata.Message, '', {
          duration: 2000,
          verticalPosition:"top",
          extraClasses: ['bg-red']
        });

        this.notification = [];
        this.totalRecords = 0 ;
      }
    },(err: any) => console.log("error", err),() =>
      console.log("getCustomersPage() retrieved customers for page:", +page)
    );
  }

  onSubmit() {
    this.getnotificationlist(1, this.notificationfilter);
  }

  clearfilter() {
    this.notificationfilter.notificationtitle = "";
    this.notificationfilter.notificationstatus = "";
    this.notificationfilter.appname = "";
    this.notificationfilter.screenname = "";
    this.getnotificationlist(1, this.notificationfilter);
  }

  pageChanged(event) {
    this.getnotificationlist(event, this.notificationfilter);
  }

  statuschange(notificationid:any, status:any) {
    this.notificationservice.updatestatus(notificationid, status).subscribe((response) => {
      if (response.status_code == 200) {
        this.snackBar.open(response.Metadata.Message, '', {
          duration: 2000,
           verticalPosition:"top",
          extraClasses: ['bg-green']
        });
      } else {
        this.snackBar.open(response.Metadata.Message, '', {
          duration: 2000,
           verticalPosition:"top",
          extraClasses: ['bg-red']
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/component/notificationmaster/notification-master.component.ts